<template>
  <div>
    <!-- Commandes Vacances -->
    <OrdersIResaList :customer="content" />

    <!-- Commandes Loisirs -->
    <OrdersAlphaList :customer="content" />

    <ReferralCodesList :customer="content" />

    <ReferralsList :customer="content" />

    <!-- Affectation de Produits -->
    <AllowedProducts :customer="content" />
  </div>
</template>

<script>
import OrdersAlphaList from '@/components/profile/OrdersAlphaList';
import OrdersIResaList from '@/components/profile/OrdersIResaList';
import ReferralsList from '@/components/profile/ReferralsList';
import ReferralCodesList from '@/components/profile/ReferralCodesList';
import AllowedProducts from '@/components/profile/AllowedProducts';

export default {
  name: 'ProfileTransactions',
  components: {
    OrdersAlphaList,
    OrdersIResaList,
    ReferralsList,
    ReferralCodesList,
    AllowedProducts
  },
  props: {
    content: {
      type: Object,
      default: null
    }
  }
};
</script>
